import { CSSObject, css } from '@emotion/react'

const customIconColors = {
  blue: '#00A2C7',
  grey: '#6F7D89',
  orange: '#F7693C',
}

export const iconStyles = (color?: 'orange' | 'blue' | 'grey'): CSSObject => ({
  color: color ? customIconColors[color] : 'currentColor',
  fill: color ? customIconColors[color] : 'currentColor',
  blockSize: 14,
  inlineSize: 14,
})

export const imageStyles = css({
  borderRadius: 2,
  blockSize: 12,
  position: 'relative',
  // required to match icon alignment for some reason?
  insetInlineStart: 2,
  inlineSize: 12,
})

export const imageContainer = css({
  blockSize: 16,
  inlineSize: 16,
})
